// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Loading_Wrapper__xzQ7s","card":"Loading_card__1Gn1N","progress":"Loading_progress__PfV7s","dotWrapper":"Loading_dotWrapper__10sOU","dot":"Loading_dot__1YsMc"};